import { DisputListModel } from '@/features/orders/model/types'
import { MobileBlockOrder } from './MobileBlock/MobileBlockOrder'

export const MobileBlocksOrders = ({
  data,
  openDisputDialog,
  inProgressDisputDialog,
}: {
  data: DisputListModel[]
  openDisputDialog: (id: string) => void
  inProgressDisputDialog: (id: string) => void
}) => {
  return (
    <>
      {data.map((disput) => (
        <MobileBlockOrder
          key={disput.id}
          disput={disput}
          openDisputDialog={openDisputDialog}
          inProgressDisputDialog={inProgressDisputDialog}
        />
      ))}
    </>
  )
}
